module.exports = __webpack_public_path__ + "static/techup-9d9c61156a45aa1be9e068cc0a9b9345.png";